module.exports = __webpack_public_path__ + "static/media/IMG_0066.837808f8.jpg";